
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from '@/lib/Question';
    import moment from 'moment';
    /*import * as M from '@@t/materialize-css';*/
    @Component({})
    export default class DatePickerQuestion extends Vue {
        @Prop() public question?: Question;
        public static displayFormat = 'DD MMMM YYYY';
        public static apiFormat = 'DD-MM-YYYY';
        private instance: any;

        public static transform(dateString: string) {
            return moment(dateString.toLowerCase(), DatePickerQuestion.displayFormat).format(DatePickerQuestion.apiFormat);
        }

        public static transformBack(dateString: string) {
            return moment(dateString.toLowerCase(), DatePickerQuestion.apiFormat).format(DatePickerQuestion.displayFormat);
        }

        validate(event: any) {
            this.question!.validate();
            this.question!.changedEvent.emit('');
        }


        public mounted() {
            const picker = this.$refs['input-' + this.question!.id] as Element;
            this.instance = M.Datepicker.init(picker, {
                format: DatePickerQuestion.displayFormat.toLowerCase(),
                autoClose: true,
                minDate: new Date(),
                firstDay: 1,
                i18n: {
                    cancel: 'Annuler',
                    clear: 'Effacer',
                    done: 'Ok',
                    months: [
                        'Janvier',
                        'Février',
                        'Mars',
                        'Avril',
                        'Mai',
                        'Juin',
                        'Juillet',
                        'Aout',
                        'Septembre',
                        'Octobre',
                        'Novembre',
                        'Decembre',
                    ],
                    monthsShort: [
                        'Jan',
                        'Fev',
                        'Mar',
                        'Avr',
                        'Mai',
                        'Juin',
                        'Juil',
                        'Aout',
                        'Sep',
                        'Oct',
                        'Nov',
                        ',Dec'
                    ],
                    weekdays: [
                        'Dimanche',
                        'Lundi',
                        'Mardi',
                        'Mercredi',
                        'Jeudi',
                        'Vendredi',
                        'Samedi',
                    ],
                    weekdaysShort: [
                        'Dimanche',
                        'Lundi',
                        'Mardi',
                        'Mercredi',
                        'Jeudi',
                        'Vendredi',
                        'Sam,edi'
                    ],
                    weekdaysAbbrev: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
                    showClearBtn: true,

                }
            });
            if (!this.question!.currentResponseIsEmpty()) {
                this.instance.setDate(moment(this.question!.currentResponse!.value, DatePickerQuestion.displayFormat).toDate());
            }

        }

        public beforeDestroy() {
            const instance = M.Datepicker.getInstance(this.$refs['input-' + this.question!.id] as Element);
            instance.destroy();
        }
    }
